import {Pipe, PipeTransform} from '@angular/core';
import {TIPO_META_CONFIG, TipoMeta} from '@core/models/meta';

@Pipe({name: 'metaValor'})
export class MetaValorPipe implements PipeTransform {
  transform(valor: number | null | undefined, tipo: TipoMeta): string {
    if (valor === null || valor === undefined) return '—';
    return TIPO_META_CONFIG[tipo].formatValor(valor);
  }
}
